<p class="mt-0">
  <ng-container *ngIf="mode === 'DDT'; else onlyUnload">
    Gli asset scelti escono dalla lista RAEE con un DDT verso il fornitore indicato: la giacenza
    della sede scende, gli asset diventano non attivi e restano consultabili con il loro storico e
    con il DDT.
  </ng-container>
  <ng-template #onlyUnload>
    Gli asset scelti escono dalla lista RAEE: la giacenza della sede scende, gli asset diventano non
    attivi e restano consultabili con il loro storico.
  </ng-template>
</p>

<p-message
  severity="warn"
  styleClass="w-full mb-3"
  text="L'operazione non si annulla dall'applicazione."></p-message>

<div class="mb-3">
  <span class="font-bold">{{
    assets.length === 1 ? 'Asset' : 'Asset (' + assets.length + ')'
  }}</span>
  <small
    *ngIf="mode === 'DDT'"
    class="block text-color-secondary"
    >{{
      warehousesCount === 1
        ? 'Viene creato 1 DDT'
        : 'Vengono creati ' + warehousesCount + ' DDT (uno per magazzino)'
    }}<ng-container *ngIf="agreementsCount > 1"
      >; gli asset sono di {{ agreementsCount }} commesse, che possono stare nello stesso
      DDT</ng-container
    >.</small
  >
  <small
    *ngIf="mode !== 'DDT' && agreementsCount > 1"
    class="block text-color-secondary"
    >Sono di {{ agreementsCount }} commesse: viene registrato uno scarico per ciascuna.</small
  >
  <ul class="dispose-assets mt-2">
    <li *ngFor="let a of assets">
      <span class="font-bold">{{ a.serial_number }}</span>
      <span
        *ngIf="a.related_product?.name"
        class="ml-2"
        >{{ a.related_product?.name }}</span
      >
      <small class="block text-color-secondary"
        >{{ a.related_warehouse?.name
        }}<ng-container *ngIf="a.related_agreement?.name">
          · {{ a.related_agreement?.name }}</ng-container
        ></small
      >
    </li>
  </ul>
</div>

<div
  class="mb-3"
  *ngIf="mode === 'DDT'">
  <label
    for="dispose-supplier"
    class="block mb-2"
    >Destinatario del DDT (fornitore)</label
  >
  <p-autoComplete
    inputId="dispose-supplier"
    [formControl]="supplier"
    [suggestions]="suggestedSuppliers"
    (completeMethod)="filterSuppliers($event)"
    field="name"
    dataKey="id"
    [emptyMessage]="'Nessun fornitore trovato'"
    [forceSelection]="true"
    [showClear]="true"
    styleClass="w-full"
    placeholder="Cerca un'azienda...">
    <ng-template
      let-registry
      pTemplate="item">
      <div>
        {{ registry.name }}
        <small
          *ngIf="registry.vat_number"
          class="text-color-secondary"
          >({{ registry.vat_number }})</small
        >
      </div>
    </ng-template>
  </p-autoComplete>
</div>

<div class="mb-3">
  <label
    for="dispose-notes"
    class="block mb-2"
    >Note (obbligatorie): riferimento dello smaltimento, ad esempio il numero del FIR</label
  >
  <textarea
    id="dispose-notes"
    [formControl]="notes"
    rows="3"
    class="w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"></textarea>
  <small
    *ngIf="mode === 'DDT'"
    class="block text-color-secondary mt-1"
    >Le note compaiono anche sul DDT.</small
  >
</div>

<div class="flex align-items-center gap-2 mb-3">
  <p-checkbox
    [formControl]="acknowledged"
    [binary]="true"
    inputId="dispose-ack"></p-checkbox>
  <label for="dispose-ack">Ho capito: lo smaltimento è definitivo</label>
</div>

<p-message
  *ngIf="errorMessage"
  severity="error"
  styleClass="w-full mb-3"
  [text]="errorMessage"></p-message>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"
      [disabled]="isLoading"></p-button>
    <p-button
      [label]="mode === 'DDT' ? 'Smaltisci con DDT' : 'Smaltisci'"
      (onClick)="submit()"
      styleClass="butt"
      [rounded]="true"
      [loading]="isLoading"
      [disabled]="!canSubmit"></p-button>
  </div>
</div>
